import styled from "styled-components";
// USED ONLY FOR SELECTING
export const StyledTableActionColumnContainer = styled.div.withConfig({ displayName: "StyledTableActionColumnContainer_APC-7311-productShell", componentId: "sc-17oxw1i" })({});
export const StyledTableActionButtonsContainer = styled.div.withConfig({ displayName: "StyledTableActionButtonsContainer_APC-7311-productShell", componentId: "sc-1ewsdc9" })({
    opacity: 0,
});
//# sourceMappingURL=TableActionColumn.style.js.map